import { render, staticRenderFns } from "./UpdateReceptionnaire.vue?vue&type=template&id=efd5c428&"
import script from "./UpdateReceptionnaire.vue?vue&type=script&lang=js&"
export * from "./UpdateReceptionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports